import { Pages } from 'modules/navigation/domain/enums/pages';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useEffect, useMemo } from 'react';
import { SyncLoader } from 'react-spinners';
import ImgNotFound from 'ud-ui/components/images/not-found.png';
import { useIsAdmin } from 'shared/hooks/use-is-admin';
import { history } from 'store/store';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { useOrganizerById } from '../../hooks/use-organizer-by-id';
import OrganizerInfo from '../../components/organizer-info';
import Balance from '../../elements/balance/balance';
import { MainBlock } from './styles';

function OrganizerCard() {
  const { info } = useOrganizer();
  const { organizer, isLoading, isError, switchOrganizer } = useOrganizerById();
  const { setHeaderContent } = useMainLayout();

  const isCurrentOrganizer = useMemo(() => {
    return info?.id === organizer?.id;
  }, [info, organizer]);

  const breadcrumbs = useMemo(() => {
    const items = [{ label: 'Организаторы', to: Pages.ORGANIZERS.INDEX }];

    const { name, id } = organizer ?? {};
    if (name && id) {
      items.push({ label: name, to: Pages.ORGANIZERS.builders.view(id) });
    }

    return items;
  }, [organizer]);

  useEffect(() => {
    setHeaderContent(<UDBreadcrumbs breadcrumbs={breadcrumbs} />);
    return () => setHeaderContent(null);
  }, [breadcrumbs, setHeaderContent]);

  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex-center w-full px-6" style={{ height: '100%', minHeight: 'calc(100vh - 241px)' }}>
        <SyncLoader />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex-center w-full px-6" style={{ height: '100%', flexDirection: 'column' }}>
        <img style={{ width: 130, height: 130 }} alt="error" src={ImgNotFound} />
        <UDText type="callout" className="text-surfaceRomanSilver30">
          Ошибка загрузки данных. Попробуйте обновить страницу.
        </UDText>
      </div>
    );
  }

  return (
    <>
      <MainBlock>
        <div className="flex items-center justify-between w-full px-6 flex flex-row py-3">
          <div className="flex items-center gap-6">
            <UDText type="headline">Информация об организаторе</UDText>
            <UDButton
              onClick={() => history.push(Pages.ORGANIZERS.INDEX)}
              className={'flex-center'}
              variant={'primary'}
              style={{ height: 36 }}
            >
              Вернуться к списку
            </UDButton>
            {!isCurrentOrganizer && (
              <UDButton onClick={switchOrganizer} className={'flex-center'} variant={'primary'} style={{ height: 36 }}>
                Переключиться на {organizer?.name}
              </UDButton>
            )}
          </div>

          <Balance organizer={organizer} />
        </div>
        <div className="flex items-center border-b border-surfacePlatinum20 w-full px-6" />
        <div className="w-full px-6 py-6">
          <OrganizerInfo organizer={organizer} />
        </div>
      </MainBlock>
    </>
  );
}

export default OrganizerCard;
